import { render } from "./HandleChartView.vue?vue&type=template&id=3827381c&ts=true"
import script from "./HandleChartView.vue?vue&type=script&lang=ts"
export * from "./HandleChartView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__